import { InputBase, InputAdornment } from "@mui/material";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import searchDebounce from "./searchDebouncing";

const SearchContainer = styled('div')(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: 10,
    backgroundColor: theme.palette.background.subtle || theme.palette.grey[50],
    border: `1px solid transparent`,
    transition: "all 150ms ease",
    minWidth: 260,
    maxWidth: 400,
    "&:hover": {
        borderColor: theme.palette.divider,
    },
    "&:focus-within": {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
        backgroundColor: theme.palette.background.paper,
    },
    [theme.breakpoints.down('sm')]: {
        minWidth: "100%",
        maxWidth: "100%",
    },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    flex: 1,
    fontSize: "0.9375rem",
    color: theme.palette.text.primary,
    '& .MuiInputBase-input': {
        padding: 0,
        "&::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 0.7,
        },
    },
}));

const SearchInput = ({ setSearchQuery, placeholder = "Search...", defaultValue = "" }) => {
    const debouncedSearch = searchDebounce((query) => { setSearchQuery(query); }, 300);

    return (
        <SearchContainer>
            <InputAdornment position="start" sx={{ mr: 1, color: 'text.secondary' }}>
                <SearchIcon fontSize="small" />
            </InputAdornment>
            <StyledInputBase
                placeholder={placeholder}
                defaultValue={defaultValue}
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => { debouncedSearch(e.target.value); }}
            />
        </SearchContainer>
    );
};

export default SearchInput;
